(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafeoni-coffee-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){
  const radio=event.target.closest('.cafeoni-decaf-home__radio');
  if(!radio)return;
  const root=radio.closest('[data-decaf-home]');
  const form=radio.closest('form');
  if(!root||!form)return;
  const qty=form.querySelector('input[name="quantity"]');
  if(qty)qty.value=radio.dataset.kg;
  const total=root.querySelector('[data-decaf-total]'),unit=root.querySelector('[data-decaf-unit]'),saving=root.querySelector('[data-decaf-saving]'),shipping=root.querySelector('[data-decaf-shipping]');
  if(total)total.textContent=radio.dataset.total;
  if(unit)unit.textContent='('+radio.dataset.unit+'/kg)';
  if(saving)saving.textContent=Number(radio.dataset.kg)>1?radio.dataset.saving+' sparen':'';
  if(shipping){const free=Number(radio.dataset.totalCents)>=10000;shipping.hidden=false;shipping.textContent=free?'✓ Versandkostenfrei innerhalb Deutschlands':'5,00 € Versand (DE)';}
});
document.addEventListener('submit',function(event){
  const root=event.target.querySelector('[data-decaf-home]');
  if(!root)return;
  const checked=root.querySelector('.cafeoni-decaf-home__radio:checked');
  const qty=event.target.querySelector('input[name="quantity"]');
  if(checked&&qty)qty.value=checked.dataset.kg;
},true);

document.addEventListener('click', function(event) {
  const addButton = event.target.closest('[data-coffee-variant-add]');
  if (!addButton) return;
  const form = addButton.closest('.cafeoni-coffee-guide__buy-form');
  const variantInput = form && form.querySelector('[data-coffee-selected-variant]');
  if (variantInput) variantInput.value = addButton.dataset.variantId;
  const qtyInput = form && form.querySelector('input[name="quantity"]');
  if (qtyInput && addButton.dataset.coffeeQty) qtyInput.value = addButton.dataset.coffeeQty;
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafeoni-machines"] && !Shopify.designMode) return;
  try {
    
const cafeoniMachineProfiles = {
  'Franke A300': { type: 'automatic', capacity: 80, drinks: ['espresso', 'milk', 'hotwater'] },
  'Franke A400': { type: 'automatic', capacity: 100, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Franke A600': { type: 'automatic', capacity: 200, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Franke A800': { type: 'automatic', capacity: 250, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Franke A1000': { type: 'automatic', capacity: 300, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Franke S700': { type: 'automatic', capacity: 250, drinks: ['espresso', 'milk', 'hotwater'] },
  'Franke SB1200': { type: 'automatic', capacity: 250, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S1 Espresso': { type: 'automatic', capacity: 60, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S1 Instant': { type: 'automatic', capacity: 80, drinks: ['milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S2 Instant': { type: 'automatic', capacity: 100, drinks: ['milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S4 Instant': { type: 'automatic', capacity: 250, drinks: ['milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S5 Espresso': { type: 'automatic', capacity: 300, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S5 Instant': { type: 'automatic', capacity: 300, drinks: ['milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro X1 Espresso': { type: 'automatic', capacity: 150, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro X1 MIA': { type: 'automatic', capacity: 100, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro X3 Espresso': { type: 'automatic', capacity: 210, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro X4 Espresso': { type: 'automatic', capacity: 300, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro X5': { type: 'automatic', capacity: 300, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Azkoyen Vitro S5 MIA': { type: 'automatic', capacity: 250, drinks: ['espresso', 'milk', 'cocoa', 'hotwater'] },
  'Dalla Corte Studio': { type: 'portafilter', capacity: 30, drinks: ['espresso', 'milk', 'hotwater'] },
  'Dalla Corte Mina': { type: 'portafilter', capacity: 60, drinks: ['espresso', 'milk', 'hotwater'] },
  'Dalla Corte XT Barista': { type: 'portafilter', capacity: 250, drinks: ['espresso', 'milk', 'hotwater'] }
};

function cafeoniInitMachineFinder(section) {
  const finder = section.querySelector('[data-machine-finder]');
  if (!finder || finder.dataset.initialized === 'true') return;
  finder.dataset.initialized = 'true';
  const result = section.querySelector('[data-finder-result]');
  const error = section.querySelector('[data-drink-error]');
  const empty = section.querySelector('[data-finder-empty]');
  const matches = Array.from(section.querySelectorAll('[data-finder-model]'));

  finder.addEventListener('submit', function(event) {
    event.preventDefault();
    const cupsInput = finder.querySelector('input[name^="finder-cups-"]:checked');
    const typeInput = finder.querySelector('input[name^="finder-type-"]:checked');
    const drinkInputs = Array.from(finder.querySelectorAll('input[name^="finder-drinks-"]:checked'));
    if (!cupsInput || !typeInput) {
      finder.reportValidity();
      return;
    }
    if (drinkInputs.length === 0) {
      error.hidden = false;
      finder.querySelector('[data-drink-group]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    error.hidden = true;
    const cups = Number(cupsInput.value);
    const machineType = typeInput.value;
    const drinks = drinkInputs.map(input => input.value);
    const ranked = matches.map(match => {
      const profile = cafeoniMachineProfiles[match.dataset.finderModel];
      return { match, profile };
    }).filter(item => {
      if (!item.profile) return false;
      if (machineType !== 'unsure' && item.profile.type !== machineType) return false;
      if (item.profile.capacity < cups) return false;
      return drinks.every(drink => item.profile.drinks.includes(drink));
    }).map(item => {
      const capacityDifference = item.profile.capacity - cups;
      const score = 100 - Math.min(capacityDifference / 5, 40);
      return { match: item.match, score };
    }).sort((left, right) => right.score - left.score);

    matches.forEach(match => { match.hidden = true; });
    ranked.slice(0, 3).forEach(item => { item.match.hidden = false; });
    if (empty) empty.hidden = ranked.length > 0;
    result.hidden = false;
    let specialist = result.querySelector('[data-specialist-finder]');
    if (!specialist) { specialist = document.createElement('div'); specialist.dataset.specialistFinder = ''; specialist.className = 'cm-specialist-finder'; result.append(specialist); }
    specialist.hidden = machineType !== 'portafilter';
    if (machineType === 'portafilter') {
      matches.forEach(match => { match.hidden = true; });
      if (empty) empty.hidden = true;
      specialist.innerHTML = '<h3>Siebträger nach Einsatz und Ausstattung auswählen</h3><p>Bei Siebträgern entscheiden Brühgruppen, Wasserversorgung und Bedienablauf. Vergleichen Sie alle zehn Dalla-Corte-Maschinenlinien im spezialisierten Finder. Die Tagesmenge allein ist keine bestätigte Leistungszusage.</p><a class="cm-button" href="/pages/dalla-corte-siebtraegermaschinen#dalla-corte-maschinenfinder">Dalla Corte Maschinenfinder öffnen</a>';
    }

    const contactForm = section.querySelector('.cm-form');
    const cupsField = contactForm && contactForm.querySelector('[data-finder-contact-cups]');
    const drinksField = contactForm && contactForm.querySelector('[data-finder-contact-drinks]');
    const typeField = contactForm && contactForm.querySelector('[data-finder-contact-type]');
    const numericCups = contactForm && contactForm.querySelector('input[name="contact[Tassen pro Tag]"]');
    if (cupsField) cupsField.value = cupsInput.nextElementSibling.textContent.trim();
    if (drinksField) drinksField.value = drinkInputs.map(input => input.nextElementSibling.textContent.trim()).join(', ');
    if (typeField) typeField.value = typeInput.nextElementSibling.textContent.trim();
    if (numericCups) numericCups.value = cups;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  const reset = section.querySelector('[data-finder-reset]');
  if (reset) reset.addEventListener('click', function() {
    finder.reset();
    result.hidden = true;
    error.hidden = true;
    finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

document.querySelectorAll('.cafeoni-machines').forEach(function(section) {
  cafeoniInitMachineFinder(section);
  const params = new URLSearchParams(window.location.search);
  const requestedModel = params.get('maschine');
  const requestedType = params.get('anfrage');
  const requestedBrand = params.get('hersteller');
  if (!requestedModel && !requestedType && !requestedBrand) return;
  const modelSelect = section.querySelector('[data-machine-select]');
  const requestSelect = section.querySelector('[data-machine-request-select]');
  const brandField = section.querySelector('[data-machine-brand-field]');
  if (modelSelect && requestedModel) modelSelect.value = requestedModel;
  if (requestSelect && requestedType) requestSelect.value = requestedType;
  if (brandField && requestedBrand) brandField.value = requestedBrand;
  const advice = section.querySelector('.cm-advice');
  if (advice) advice.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.cafeoni-machines');
  if (section) cafeoniInitMachineFinder(section);
});
document.addEventListener('click', function(event) {
  const link = event.target.closest('.cafeoni-machines [data-machine]');
  if (!link) return;
  const section = link.closest('.cafeoni-machines');
  const select = section.querySelector('[data-machine-select]');
  if (select) {
    select.value = link.dataset.machine;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const requestSelect = section.querySelector('[data-machine-request-select]');
  if (requestSelect && link.dataset.machineRequest) {
    requestSelect.value = link.dataset.machineRequest;
    requestSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

  } catch(e) { console.error(e); }
})();
})();
